import { render } from "./MobileMessageWidget.vue?vue&type=template&id=8815be66&scoped=true"
import script from "./MobileMessageWidget.vue?vue&type=script&lang=js"
export * from "./MobileMessageWidget.vue?vue&type=script&lang=js"

import "./MobileMessageWidget.vue?vue&type=style&index=0&id=8815be66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8815be66"]])

export default __exports__